/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedRingSizeDetail_detailValues = ReadonlyArray<{
    readonly detailKey: string | null;
    readonly ringSizes?: ReadonlyArray<{
        readonly unit: string | null;
        readonly value: string | null;
    } | null> | null;
    readonly " $refType": "PdpSharedRingSizeDetail_detailValues";
}>;
export type PdpSharedRingSizeDetail_detailValues$data = PdpSharedRingSizeDetail_detailValues;
export type PdpSharedRingSizeDetail_detailValues$key = ReadonlyArray<{
    readonly " $data"?: PdpSharedRingSizeDetail_detailValues$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedRingSizeDetail_detailValues">;
}>;



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "PdpSharedRingSizeDetail_detailValues",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "detailKey",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RingSizeDetail",
          "kind": "LinkedField",
          "name": "ringSizes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "unit",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "PdpDetailRingSize",
      "abstractKey": null
    }
  ],
  "type": "PdpDetailValueInterface",
  "abstractKey": "__isPdpDetailValueInterface"
};
(node as any).hash = '12c90af03dc8b2b9e9211795e1a365d2';
export default node;
